import image1 from "../assets/t-image1.png";
import image2 from "../assets/coachT.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'DANTE',
    status : 'CUSTOMER'
  },
  {
    image: image2,
    review: 'With a deep understanding of fitness principles, i tailor my coaching approach to suit the diverse needs of each individual. My clear communication and personalized guidance empower my clients to push their limits while maintaining a focus on proper form and safety.',
    name: 'JOSE',
    status: 'COACH'
  },
  {
    image : image3,
    review:'I stand before you today as a proud member of this incredible gym community. When I walked through those doors for the first time, I never imagined the impact it would have on my life. This place is not just about lifting weights or running on treadmills; its about transformation, both physically and mentally.',
    name: 'KEVIN TINGA',
    status: "CUSTOMER"
  }
];
